<template>
  <div class="navbar" id="topbar">
    <div class="navbar-top">
      <div class="navbar-top-side">
        <Icon
          iconClass="pointer"
          icon="menuIcon"
          :xlarge="true"
          color="grey darken-2"
          @click.native="sidebar()"
        />
      </div>
      <div class="navbar-top-logo pointer" @click="changeRoute('/', true)">
        <Logo
          :slogan="$vuetify.breakpoint.mdAndUp"
          :size="$vuetify.breakpoint.name"
        />
      </div>
      <div v-if="$vuetify.breakpoint.smAndDown" class="navbar-top-side">
        <notifications
          v-if="logged"
          shrink
          class="pa-0 ma-0 topbar-btn"
          :devices="devices"
        ></notifications>
      </div>
    </div>
    <div
      v-if="showBottom && swipDisplay"
      :class="[
        'navbar-bottom',
        $vuetify.breakpoint.smAndDown ? 'small-bar' : '',
      ]"
    >
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-layout
          row
          wrap
          align-baseline
          class="grey--text text--darken-3 px-2 shrink"
        >
          <h2>{{ business.custom ? business.title : business.name }}</h2>
          <h3 class="ms-4 username">{{ username }}</h3>
        </v-layout>
        <span v-if="isHome">
          <!-- <home-buttons /> -->
          <div class="">
            <v-btn
              @click="changeRoute('/')"
              small
              text
              elevation="0"
              :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
            >
              <v-icon>{{ "mdi-view-dashboard" }} </v-icon></v-btn
            >
            <v-btn
              @click="changeRoute('/devices')"
              small
              text
              elevation="0"
              :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
            >
              {{ $t("links.all-devices") }}</v-btn
            >
            <v-btn
              @click="changeRoute('/groups')"
              small
              text
              elevation="0"
              :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
              >{{ $t("links.groups") }}</v-btn
            >
          </div>
        </span>
        <span v-if="!isHome" class="backBtn d-flex">
          <v-btn
            color="switchq"
            text
            height="auto"
            @click="changeRoute('/', true)"
          >
            <Icon icon="dashboard" iconClass="ms-1" :small="false" />
          </v-btn>
          <v-btn
            @click="changeRoute('/devices')"
            small
            text
            elevation="0"
            :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
          >
            {{ $t("links.all-devices") }}</v-btn
          >
          <v-btn
            @click="changeRoute('/groups')"
            small
            text
            elevation="0"
            :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
            >{{ $t("links.groups") }}</v-btn
          >
          <v-divider vertical></v-divider>
          <v-btn color="switchq" text height="auto" @click="$router.go(-1)">
            {{ $t("back") }}
            <Icon icon="returnIcon" iconClass="ms-1" :small="false" />
          </v-btn>
          <search-input
            v-if="this.$route.path.includes('devices')"
            @close="search = false"
            :focused="search"
          />
        </span>
        <search-input v-if="isHome" @close="search = false" :focused="search" />
        <!-- v-if="
            (isHome && devicesPage == 'devices') ||
            (isHome && devicesPage != 'groups')
          " -->
        <!-- <v-flex xs4 v-if="isHome && devicesPage == 'devices'">
          <span>
            <search-input />
          </span>
        </v-flex> -->
        <div class="navbar-bottom-time-data grey--text text--darken-3">
          <div v-if="$vuetify.breakpoint.lgAndUp" id="navbar-bottom-time">
            <span>
              {{ time.format("D MMMM YYYY") }}
            </span>
            <span id="time-divider">|</span>
            <span class="time-cont">
              {{ time.format("HH:mm") }}
            </span>
          </div>
          <notifications
            v-if="logged"
            shrink
            class="pa-0 ma-0 topbar-btn"
            :devices="devices"
          ></notifications>
        </div>
      </template>
      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-layout row wrap justify-space-between align-center>
          <!-- ------------------------------------------------------------------------------------ 1 -->
          <div
            class="d-flex w-100 justify-space-between"
            xs6
            v-if="!search && !isHome"
          >
            <!-- ------------------------------------------------------------------------------------ 2 -->
            <!-- <span> -->
            <!-- <Icon icon="search" iconClass="ms-1" :small="true" /> -->
            <home-buttons />
            <v-icon @click="$router.go(-1)" title="back"
              >mdi-keyboard-return</v-icon
            >
            <!-- <Icon
              icon="returnIcon"
              iconClass=""
              :small="true"
              @click="$router.go(-1)"
            /> -->

            <!-- <v-spacer v-if="!search && isHome"></v-spacer> -->
            <!-- </span> -->
            <!-- <span v-if="search">
              <search-input />
            </span> -->
            <!-- ------------------------------------------------------------------------------------ 2 -->
          </div>
          <div
            class="d-flex w-100 justify-space-between"
            xs6
            v-if="!search && isHome && devicesPage != 'groups'"
          >
            <!-- ------------------------------------------------------------------------------------ 2 -->
            <!-- <span> -->
            <!-- <Icon icon="search" iconClass="ms-1" :small="true" /> -->
            <home-buttons />
            <v-icon @click="search = true">search</v-icon>

            <!-- <v-spacer v-if="!search && isHome"></v-spacer> -->
            <!-- </span> -->
            <!-- <span v-if="search">
              <search-input />
            </span> -->
            <!-- ------------------------------------------------------------------------------------ 2 -->
          </div>
          <!-- <v-flex> -->
          <!-- ------------------------------------------------------------------------------------ 3 -->
          <!-- <span v-if="isHome && devicesPage == 'devices'">
              <search-input />
            </span> -->
          <!-- <span v-if="isHome && !search">
            </span> -->
          <!-- ------------------------------------------------------------------------------------ 4 -->
          <div v-if="search" class="d-flex w-100 justify-space-between">
            <search-input @close="search = false" :focused="search" />
            <v-btn
              color="info"
              class="me-n5"
              text
              height="auto"
              @click="closeSearch()"
            >
              <Icon icon="mdiClose" iconClass="" />
            </v-btn>
          </div>

          <!-- ------------------------------------------------------------------------------------ 4 -->
          <!-- ------------------------------------------------------------------------------------ 3 -->
          <!-- </v-flex> -->
          <!-- <div
            v-if="!isHome"
            class="backBtn d-flex w-100 justify-space-between"
          > -->
          <!-- <v-btn
              color="info"
              text
              height="auto"
              @click="changeRoute('/', true)"
            >
              <Icon icon="dashboard" iconClass="ms-1" :small="false" />
            </v-btn> -->
          <!-- <v-divider vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <!-- <home-buttons />
            <v-btn color="info" text height="auto" @click="$router.go(-1)">
              {{ $t("back") }}
              <Icon icon="returnIcon" iconClass="" :small="true" />
            </v-btn>
          </div> -->
          <!-- <v-spacer
            v-if="isHome && devicesPage == 'devices' && !search"
          ></v-spacer>
          <div
            class="d-flex"
            xs6
            v-if="isHome && devicesPage == 'devices' && !search"
          > -->
          <!-- <span> -->
          <!-- <Icon icon="search" iconClass="ms-1" :small="true" /> -->
          <!-- <v-icon @click="search = true">search</v-icon> -->
          <!-- </span> -->
          <!-- <span v-if="search">
              <search-input />
            </span> -->
          <!-- </div> -->
          <!-- ------------------------------------------------------------------------------------ 1 -->
        </v-layout>
      </template>
    </div>
  </div>
</template>

<script>
import Notifications from "./notifications";
import Logo from "@/components/app_parts/logo.vue";
import HomeButtons from "./HomeButtons.vue";
import SearchInput from "./SearchInput.vue";
export default {
  name: "TopBar",
  components: { Notifications, Logo, HomeButtons, SearchInput },
  // components: { Notifications, Logo, SearchInput },
  props: ["devices", "swipDisplay"],
  data() {
    return {
      clipped: true,
      openedMenu: null,
      title: "SwitchQ",
      logged: true,
      locale: null,
      devicesPage: localStorage.getItem("homePage"),
      search: false,
    };
  },
  computed: {
    backRoute() {
      let back = this.$route.path.split("/");
      back.pop();
      back = back.join("/");
      // console.log("back", back);
      return back;
    },
    showBottom() {
      return true;
    },
    // isHome() {
    //   return ["/devices", "/groups"].includes(this.$route.path);
    //   //  ||
    //   // this.$route.path == "https://app.switchq.com/" ||
    //   // this.$route.path == "http://localhost:8080/"
    // }
    isHome() {
      return (
        this.$route.path == "/" ||
        ["/devices", "/groups"].includes(this.$route.path)
      );
    },
    path() {
      return this.$route.path;
    },
    time() {
      const time = this.$store.getters["general/time"];
      return time;
    },
    username() {
      return this.$store.getters["user/name"];
    },
    business() {
      return this.$store.getters["business/business"];
    },
  },
  created() {
    this.$store.dispatch("general/startTimeInterval");
  },
  watch: {
    path: {
      handler() {
        this.devicesPage = localStorage.getItem("homePage");
        this.closeSearch();
        // console.log(
        //   "is Home",
        //   this.isHome,
        //   this.$route,
        //   "devicesPage",
        //   this.devicesPage
        // );
      },
      deep: true,
    },
    // search: {
    //   handler() {
    //     console.log(this.search);
    //   },
    //   deep: true,
    // },
  },
  mounted() {},
  methods: {
    changeRoute(path, mainDashboard = false) {
      // console.log(this.$router);
      if (mainDashboard) {
        localStorage.setItem("homePage", "mainDash");
      }
      if (this.$router.history.current.path != path) {
        this.$router.push(path);
      }
    },
    closeSearch() {
      this.$store.dispatch("devices/setSearchDevice", "");
      this.search = false;
    },
    // changeRoute(route, mainDashboard = false) {
    //   if (mainDashboard) {
    //     localStorage.setItem("homePage", "mainDash");
    //   }
    //   if (this.$route.path !== "/") {
    //     this.$router.push(route).catch(() => {
    //       //
    //     });
    //   }
    // },
    openMenu() {
      document.getElementById("menuBtn").click();
    },
    sidebar() {
      this.$store.dispatch("general/toggleSideMenu");
    },
  },
};
</script>

<style scoped lang="scss">
.username {
  font-size: 18pt;
  font-weight: 500;
}

.backBtn {
  margin: 0 auto;
}

@media screen and (min-width: 600px) {
  .navbar-top {
    height: 140px;
  }
}
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  .navbar-top {
    background-color: #fff;
    border-bottom: 2px solid rgb(224, 227, 231);
    padding: 8px 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .navbar-top-side {
      width: 50px;
      display: flex;
      justify-content: center;
    }
  }
  .navbar-bottom {
    height: 55px;
    &.small-bar {
      height: 40px;
    }
    background-color: rgb(242, 246, 249);
    border-bottom: 2px solid rgb(224, 227, 231);
    padding: 8px 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .navbar-bottom-time-data {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      #navbar-bottom-time {
        display: flex;
        font-size: 16pt;
        margin: 0px 4px;
        span {
          margin: 0 6px;
        }
        #time-divider {
          color: #cecece;
        }
        .time-cont {
          width: 54px;
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .navbar-top {
    height: 60px;
  }
}
</style>
